<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b>{{ title }}</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <!-- Phone Field -->
  <form role="form" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">Phone<br></label>
        <div class="d-flex">
          <input
            id="input-modal-phone"
            type="tel"
            pattern="[\-+\(\)\s\d]*"
            name="phone"
            data-dd-privacy="mask"
            formControlName="phone"
            [ngClass]="{'is-invalid': partyPhone.touched && partyPhone.invalid }"
            class="form-control"
            trTrimSpaces
            [class.mr-2]="isWhatsAppEnabled()"
          />
          <tablesready-whatsapp-toggle
            *ngIf="isWhatsAppEnabled()"
            name="messagingProvider"
            formControlName="messagingProvider"
            ngbTooltip="Send via WhatsApp"
          ></tablesready-whatsapp-toggle>
        </div>
        <control-messages [control]="partyPhone"></control-messages>
      </div>

      <!-- Name Field -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-name" class="control-label">Name</label>
        <input id="input-modal-name"
               type="text"
               formControlName="name"
               name="name"
               noWhitespace
               [ngClass]="{'is-invalid': partyName.touched && partyName.invalid }"
               class="form-control"
               required
               trTrimSpaces
        />
        <control-messages [control]="partyName"></control-messages>
      </div>
    </div>

    <div class="row">
      <!-- Quoted time -->
      <div *ngIf="(!user.waitFields || user.waitFields.quoted_time)"
           class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-time" class="control-label">{{user.displayOptions?.labels?.quoted || 'quoted time' | titlecase}}</label>
        <div data-toggle="buttons" class="with-five-buttons d-flex justify-content-between">
          <input
            id="input-modal-time"
            class="form-control"
            type="number"
            name="quoted_time"
            formControlName="quoted_time"
            #quotedTime
            [ngClass]="{'is-invalid':quotedTime.touched && quotedTime.invalid}"
          />
          <button type="button" class="btn btn-info" (click)="changeQuoted(5)" id="plus-5-button">+5</button>
          <button type="button" class="btn btn-info" (click)="changeQuoted(-5)" id="minus-5-button">-5</button>
        </div>
      </div>

      <!-- Notes -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">Notes</label>
        <input *ngIf="!user?.noteOptions || user?.noteOptions.length < 1"
        type="text"
        name="note"
        formControlName="note"
        id="input-modal-note"
        class="form-control"
        trTrimSpaces
        />
        <frontend-dropdown-plain
          *ngIf="(user?.noteOptions || []).length > 0"
          elementId="input-modal-note-select"
          [items]="noteOptions"
          [multiple]="true"
          clearAllText="Clear"
          name="note"
          [addTag]="true"
          formControlName="note"
          placeholder="Select notes"
          [clearable]="true"
        ></frontend-dropdown-plain>
      </div>

      <!--<div class="col-xs-12 col-sm-12 form-group">
        <tablesready-party-custom-fields
          id="customFields"
          name="customFields"
          formControlName="customFields"
          [config]="user.partyFields"
          [country]="user.country"
        ></tablesready-party-custom-fields>
      </div>-->
    </div>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button
    type="submit"
    class="btn btn-info"
    (click)="confirm()"
    angularticsCategory="togo"
    angulartics2On="click"
    id="confirm-add-edit-party-button"
    [disabled]="this.form.invalid"
  >
    Confirm
  </button>
  <button type="button" class="btn btn-danger" (click)="cancel()">Cancel
  </button>
</div>
